import { type CSSProperties } from 'react';

import { CSS_PROPERTY_NAMES } from '@wp-block-builder/defaults';

/**
 * Removes all of the non-css values from an object, even if they are a mongoose object.
 */
export default function cleanupCssStyle(style: Record<string, unknown>) {
  const result: CSSProperties = {};
  for (const name of CSS_PROPERTY_NAMES) {
    const v = style[name];
    if (name === 'fontFamily' && v === 'inherit') {
      continue;
    }
    if (typeof v !== 'string' || v.trim().length === 0) {
      continue;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (result as any)[name] = v;
  }
  return result;
}
